<template>
    <div>
        <div @click="back" class="header border-bottom">
            <i class="iconfont">&#xe604;</i>
        </div>
        <div class="content">
            <h5>基本信息</h5>
            <div>
                <span>商品类别</span>
                <div class="item">
                    <el-cascader
                    :options="options"
                    v-model="selectedOptions3"
                    ></el-cascader>
                </div>
            </div>
            <div>
                <span>商品名称</span>
                <input type="text" required v-model="goodsname">
            </div>
            <div>
                <span>商品编码</span>
                <input type="number" required v-model="goodsid">
            </div>
            <div class="shop-img">
                <span>列表图</span>
                <uploadimg :uploadId="imgUrl1" :btnName="btnName1" v-model="imgUrl1"></uploadimg>
            </div>
            <div class="shop-img">
                <span>详情轮播图</span>
                <div class="swiper_img">
                  <uploadimg :uploadId="imgUrl2" :btnName="btnName2" v-model="imgUrl2"></uploadimg>
                  <uploadimg :uploadId="imgUrl3" :btnName="btnName3" v-model="imgUrl3"></uploadimg>
                  <uploadimg :uploadId="imgUrl4" :btnName="btnName4" v-model="imgUrl4"></uploadimg>
                  <uploadimg :uploadId="imgUrl5" :btnName="btnName5" v-model="imgUrl5"></uploadimg>
                </div>
            </div>
            <div>
                <span>规格备注</span>
                <textarea v-model="spec"></textarea>
            </div>
            <div>
                <span>注意事项备注</span>
                <textarea v-model="notice"></textarea>
            </div>
            <div>
                <span>配送方式备注</span>
                <textarea v-model="deliverymethod"></textarea>
            </div>
            <div>
                <span>联系备注</span>
                <textarea v-model="contact"></textarea>
            </div>
        </div>
        <div class="content">
            <h5>商品详情</h5>
            <div>
              <vue-html5-editor :content="content" :height="300" :show-module-name="showModuleName"
                @change="updateData" ref="editor" v-model="goodsDetail"></vue-html5-editor>
            </div>
        </div>
        <div class="content">
            <h5>其他相关</h5>
            <div>
                <span>价格</span>
                <input type="number" required v-model="price">
            </div>
            <div>
                <span>库存</span>
                <input type="number" required v-model="stock">
            </div>
        </div>
        <div class="footer">
            <button type="submit" @click="handleReleaseClick">{{state}}</button>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import uploadimg from '@/common/uploadimg'
export default {
  name: 'PosttradeCont',
  props: {
    options: Array
  },
  components: {
    uploadimg
  },
  data () {
    return {
      imgUrl1: 'uploadimg1',
      imgUrl2: 'uploadimg2',
      imgUrl3: 'uploadimg3',
      imgUrl4: 'uploadimg4',
      imgUrl5: 'uploadimg5',
      btnName1: '点击上传',
      btnName2: '点击上传',
      btnName3: '点击上传',
      btnName4: '点击上传',
      btnName5: '点击上传',
      state: '发布',
      goodsname: '',
      goodsid: '',
      spec: '',
      notice: '',
      deliverymethod: '',
      contact: '',
      goodsDetail: '',
      price: '',
      stock: '',
      selectedOptions3: ['zujian', 'data'],
      content: '',
      showModuleName: false
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleReleaseClick () {
      this.state = '发布中...'
      this.bus.$emit('loading', true)
      this.releaseyihuo()
      // 反馈
    },
    // 验证
    releaseyihuo () {
      // console.log(this.selectedOptions3[1])
      this.axios.post('/ApiMeAddGood/FrontAddGood', {
        CategoryId: this.selectedOptions3[1], // 分类id
        Name: this.goodsname, // 商品名称
        Code: this.goodsid, // 商品编码
        imgUrl: $('#' + this.imgUrl1).val(), // 列表图
        detailImgUrl1: $('#' + this.imgUrl2).val(), // 轮播图
        detailImgUrl2: $('#' + this.imgUrl3).val(),
        detailImgUrl3: $('#' + this.imgUrl4).val(),
        detailImgUrl4: $('#' + this.imgUrl5).val(),
        SpecificationRemark: this.spec, // 规格备注
        Announcements: this.notice, // 注意事项备注
        ShippingRemark: this.deliverymethod, // 配送方式备注
        ContactRemark: this.contact, // 联系备注
        Content: this.content, // 商品详情
        Price: parseInt(this.price), // 价格
        Stock: parseInt(this.stock) // 库存
      }).then(this.postReleInfoSucc)
        .catch(this.postReleInfoFail)
    },
    // 提交
    postReleInfoSucc (res) {
      this.state = '再次发布'
      res = res.data
      if (res.errorInfo === '') {
        alert('发布成功，等待审核!')
        this.$router.push({
          path: '/me'
        })
      } else {
        alert(res.errorInfo)
      }
    },
    postReleInfoFail () {
      alert('发布失败')
    },
    updateData (data) {
      // sync content to component
      this.content = data
    },
    fullScreen () {
      this.$refs.editor.enableFullScreen()
    },
    focus () {
      this.$refs.editor.focus()
    }
  }
}
</script>

<style scoped>
.iconfont{ font-size: 25px;}
.header{ padding: 10px 15px; padding-bottom: 5px;}
.content{ padding: 5px 15px; border-bottom: 5px solid #f2f2f2; padding-top: 0;}
.item{ margin-top: 5px;}
.content input{ border: 1px solid #DCDFE6; height: 30px; margin-top: 5px; border-radius: 3px;}
.content .shop-img input{ border: 0;}
.content div{ margin-bottom: 5px; font-size: 14px; display: flex; justify-content: space-between; flex-direction: column;}
.content h5{ margin: 7px 0; color: #333; font-size: 16px; font-weight: bold; font-weight: normal;}
.content span{ color: #a6a6a6;}
.content textarea{ height: 100px; width: 100%; border: 1px solid #DCDFE6; margin-top: 5px; border-radius: 3px;}
textarea{ -webkit-appearance: none;}
.content .price div{ display: inline;}
.price input{ width: 30%;}
.footer{ padding: 15px 0;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 33px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.content div.swiper_img{ display: flex; justify-content: space-around; flex-direction: row; flex-wrap: wrap;}
.content div.swiper_img .uploadimg2{ width: 50%;}
</style>



// WEBPACK FOOTER //
// src/pages/post_trade/components/Content.vue